import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { BarChart, LineChart, PieChart } from 'echarts/charts';
import {
  DataZoomComponent,
  GridComponent,
  TitleComponent,
  TooltipComponent
} from 'echarts/components';
import { use } from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { NgxEchartsDirective, NgxEchartsModule, provideEchartsCore } from 'ngx-echarts';

import { DrilldownChartNoDataAvailableModule } from '../drilldown-chart-no-data-available/drilldown-chart-no-data-available.module';
import { ChartComponent } from './chart.component';

use([
  CanvasRenderer,
  BarChart,
  LineChart,
  PieChart,
  GridComponent,
  TitleComponent,
  DataZoomComponent,
  TooltipComponent
]);

@NgModule({
  declarations: [ChartComponent],
  exports: [ChartComponent],
  imports: [
    CommonModule,
    MatIconModule,
    DrilldownChartNoDataAvailableModule,
    NgxEchartsDirective,
    NgxEchartsModule.forRoot({
      echarts: {
        use
      }
    }),
    MatIconModule
  ],
  providers: [
    provideEchartsCore({
      echarts: {
        use
      }
    })
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ChartModule {}
